import { render, staticRenderFns } from "./chartConfig.vue?vue&type=template&id=a85c2e7a&scoped=true"
import script from "./chartConfig.vue?vue&type=script&lang=js"
export * from "./chartConfig.vue?vue&type=script&lang=js"
import style0 from "./chartConfig.vue?vue&type=style&index=0&id=a85c2e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85c2e7a",
  null
  
)

export default component.exports